import React, { useState, useMemo } from "react";
import { useQueryClient } from '@tanstack/react-query'
import { Button, Row, Col, Table, Input, Tooltip, Typography } from 'antd';
import { FaPlusCircle, FaPencilAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import useClients from "../../hooks/useClients";
import { normalized } from "../../utils/string";
import auth from "../../services/authService";
import CustomerModal from "./CustomerModal";
import { clientAddres, clientFullName } from './../../utils/client';

const { Title } = Typography;

function Customers() {
    const { data, isLoading: loading } = useClients();
    const queryClient = useQueryClient();

    const [modalVisible, setModalVisible] = useState(false);
    const [search, setSearch] = useState(null);

    const dataSource = useMemo(() => {
        let tmp = data ?? [];

        // Search
        if (search) {
            tmp = tmp.filter((entry) =>
                normalized(clientFullName(entry)).includes(normalized(search)) ||
                normalized(entry.id.toString()).includes(normalized(search)) ||
                (entry.razonSocial && normalized(entry.razonSocial).includes(normalized(search))) ||
                (entry.address && normalized(clientAddres(entry)).includes(normalized(search)))
            );
        }

        // Sort
        return tmp.sort((a, b) => {
            const nameA = clientFullName(a).toUpperCase();
            const nameB = clientFullName(b).toUpperCase();
            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
        });

    }, [data, search]);

    const handleOk = (item) => {
        setModalVisible(false);
        // Agregar el nuevo cliente a la cache de React Query
        queryClient.setQueryData(['clients'], (oldData) => oldData ? [...oldData, item] : [data]);
    }

    const columns = [
        { title: 'ID', dataIndex: 'id', width: 80 },
        { title: 'Nombre', render: (_, record) => record.razonSocial ? record.razonSocial : clientFullName(record) },
        { title: 'Domicilio', render: (_, record) => clientAddres(record) },
        {
            title: '', align: 'center', width: 100,
            render: (_, record) => (
                <Tooltip title="Editar">
                    <Link className="ant-btn ant-btn-circle ant-btn-primary ant-btn-icon-only" to={`/intelinet/clientes/${record.id}`}>{<FaPencilAlt />}</Link>
                </Tooltip>)
        },
    ];

    return <>
        <CustomerModal visible={modalVisible} onOk={handleOk} onCancel={() => setModalVisible(false)}/>
        <Row gutter={[24, 24]} style={{ marginTop: '2rem', marginLeft: '2rem', marginRight: '2rem' }}>
            <Col span={24}>
                <Title level={2}>Clientes</Title>
                <hr className="hr-title" />
            </Col>
            <Col span={24}>
                <Row justify="space-between" align="middle">
                    <Col>
                        <Input placeholder="Buscar" onChange={({ target }) => setSearch(target.value)} />
                    </Col>
                    <Col>
                        <Button type="primary" icon={<FaPlusCircle />} shape="round" onClick={() => setModalVisible(true)}disabled={!auth.isInRoles('CLIENT_CREATE')}>
                            &nbsp; Nuevo
                        </Button>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Table rowKey="id" {...{ dataSource, columns, loading }} pagination={{ hideOnSinglePage: true }}  />
            </Col>
        </Row>
    </>
}

export default Customers;